export const USER_PROFILE_CONTAINER_TAG_NAME = 'user-profile-container';
